import { render, staticRenderFns } from "./_ModuleEntityPublicAccess.vue?vue&type=template&id=52c81d8a&scoped=true&"
import script from "./_ModuleEntityPublicAccess.vue?vue&type=script&lang=js&"
export * from "./_ModuleEntityPublicAccess.vue?vue&type=script&lang=js&"
import style0 from "./_ModuleEntityPublicAccess.vue?vue&type=style&index=0&id=52c81d8a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52c81d8a",
  null
  
)

export default component.exports